// @core/api/endpoints/user/invite_user.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  InviteUserRequest,
} from '../../../types/user';

const BASE_PATH = '/user';

/**
 * Invite a new user
 * Sends an invitation to a new user via email or phone number. The invitation includes a referral link tied to the inviting user for tracking referral relationships.
 */
export async function InviteUser(
  data: InviteUserRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/invite`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
